import { getFocusableElements } from "../getFocusableElements.js";

/**
 * Add tab index 0 to visible slides and -1 for hidden
 * Visibility based on param slides per view
 *
 * @param {Object} swiper - Swiper instance object
 *
 * @return {void}
 */
export function addSlidesTabIndex(swiper) {
  swiper.slides.forEach((slide, index) => {
    let currentTabIndex = "-1";

    if (
      index >= swiper.activeIndex &&
      index < swiper.activeIndex + swiper.params.slidesPerView
    ) {
      currentTabIndex = "0";
    }

    getFocusableElements(slide).forEach((element) => {
      element.setAttribute("tabindex", currentTabIndex);
    });
  });
}
